import { tWithKeyAttr as t } from "../../../i18nHelper";
import React, { useState } from "react";
import styles from "./horizontalGraph.module.css";
import { TQuestionData } from "../../../services/types/user.types";
import venchyImg from "../../../images/questionnaire_doctor.png"
import ReactDOM from "react-dom";

interface HorizontalGraphProps {
  question: TQuestionData;
  totalClients: number;
}
const colors = ['#DA1E28', '#EA8B47', '#24A148', '#457b9d'];

const HorizontalGraph: React.FC<HorizontalGraphProps> = ({ question, totalClients }) => {

  const groupedOptions = question.groups
    ?.map((group) => {
      const options = question.options.filter((opt) => opt.group?.groupId === group.groupId);
      return { group, options };
    })
    .filter(({ options }) => options.length > 0) ?? [];

  const isTotal = question.options.find(obj => obj.emotion?.isTotal);
  const noIsTotal = question.options.filter(obj => !obj.emotion?.isTotal);
  const emotionsOptions = isTotal ? [isTotal, ...noIsTotal] : question.options;

  const [hoveredLabel, setHoveredLabel] = useState<number | null>(null);
  const [tooltipPos, setTooltipPos] = useState<{ top: number; left: number } | null>(null);
  const labelRefs = React.useRef<(HTMLDivElement | null)[]>([]);
  const getColorByIndex = (index: number) => {
    if (index < colors.length) {
      const color = colors[index];
      return color;
    }
    let color = "#" + Math.floor(Math.random() * 16777215).toString(16) + ""

    return color;
  };

  return (
    <div className={styles.container}>
      {groupedOptions.map(({ group, options }, groupIdx) => (
        <div key={group.groupId} className={styles.section}>

          <div
            className={styles.label}
            ref={el => labelRefs.current[groupIdx] = el}
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "120px", // adjust as needed
              display: "inline-block",
              cursor: "pointer"
            }}
            onMouseEnter={e => {
              setHoveredLabel(groupIdx);
              const rect = labelRefs.current[groupIdx]?.getBoundingClientRect();
              if (rect) {
                setTooltipPos({
                  top: rect.bottom + 5,
                  left: rect.left
                });
              }
            }}
            onMouseLeave={() => {
              setHoveredLabel(null);
              setTooltipPos(null);
            }}
          >
            {group.groupName}
          </div>
          <div className={styles.bar}>

            {options.map((option, index) => (
              <div
                key={option.optionId}
                className={styles.segment}
                style={{
                  width: `${100 / options.length}%`,
                  backgroundColor: getColorByIndex(index),
                  borderTopLeftRadius: `${index === options.length - 1 ? "7px" : "0px"}`,
                  borderBottomLeftRadius: `${index === options.length - 1 ? "7px" : "0px"}`,
                  borderTopRightRadius: `${index === 0 ? "7px" : "0px"}`,
                  borderBottomRightRadius: `${index === 0 ? "7px" : "0px"}`,
                }}
              />
            ))}
            {options.map((option, index) => (
              <div
                key={`indicator-${option.optionId}`}
                className={styles.indicator}
                style={{
                  left: `${(100 / options.length * (index + 1)) - (50 / options.length)}%`,
                }}

              >
                <div className={styles.desc}>{option.desc}</div>
                <div className={styles.line} />
                <div className={styles.percentage}>{Math.round(option.answerPercentage)}%</div>
              </div>
            ))}
          </div>
          {hoveredLabel === groupIdx && tooltipPos && (
            ReactDOM.createPortal(
              <div
                className={styles.legendTooltip}
                style={{
                  position: "absolute",
                  top: tooltipPos.top,
                  left: tooltipPos.left,
                  zIndex: 9999
                }}
              >
                {group.groupName}
              </div>,
              document.body
            )
          )}
        </div>


      ))}


      {question.isEmotion && (
        <div className={`${styles.section} ${styles.sectionEmotion}`}>
          {/* <div className={styles.label}>
            ניתוח רגשות סופי: {Math.round(question.options.find(opt => opt.emotion?.isTotal)?.answerPercentage ?? 0) ?? ""}%
          </div> */}

          {/* Render a graph for each emotion */}
          {emotionsOptions.map((option) => (
            <div key={option.optionId} className={styles.emotionGraph}>

              <div className={`${styles.graphContainer}`}
                >

                <div 
                  className={styles.label}>{option.emotion?.isTotal ? t('FINAL_EMOTION_ANALYSIS') : option.emotion?.emotionName}</div>
                {/* Graph with three sections */}
                <div className={styles.bar}>
                  <div
                    className={styles.segment_emotion}
                    style={{
                      width: "33.33%",
                      backgroundColor: colors[0],
                    }}
                  />
                  <div
                    className={styles.segment_emotion}
                    style={{
                      width: "33.33%",
                      backgroundColor: colors[1],
                    }}
                  />
                  <div
                    className={styles.segment_emotion}
                    style={{
                      width: "33.33%",
                      backgroundColor: colors[2],
                    }}
                  />

                  {/* Indicator line */}
                  <div
                    className={styles.indicator_emotion}
                    style={{
                      left: `${Math.max(0, Math.min(Math.round(option.answerPercentage), 100))}%`, // Clamp position between 0% and 100%
                    }}
                  >
                    <img className={styles.img} src={venchyImg} alt={t('VENCHI')} />

                    <div className={styles.line_emotion} />
                    <div className={styles.percentage_emotion}>{Math.round(option.answerPercentage)}%</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

    </div>
  );
};

export default HorizontalGraph;


